import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles
} from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, setPropTypes } from 'recompose';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

const styles = {
  scrollTable: {
    // maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  btnEdit: {
    marginLeft: 'auto'
  },
  actionCell: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidth: 250,
    minWidth: 250,
    alignItems: 'center'
  },
  smallCell: {
    maxWidth: 70
  },
  mediumCell: {
    maxWidth: 250
  },
  table: {
    maxWidth: 1300
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    // state => ({}),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes)
);

const Main = enhance(
  ({
    classes,
    editBudgetMode,
    setEditBudgetMode,
    budgetAmount,
    setBudgetAmount,
    setShowPopupConfirm,
    setBudgetRowDetail,
    budgetList,
    history
  }) => {
    function goToGochiIssuance(budget) {
      history.push({
        pathname: '/gochi_issuance',
        state: {
          budget
        }
      });
    }
    const onEditBudgetMode = (e, rowData) => {
      e.preventDefault();
      setBudgetAmount('');
      setEditBudgetMode([{ row: rowData.month, editMode: true }]);
    };
    // const today = new Date();
    // const currentYear = today.getFullYear();
    // const currentMonth = today.getMonth() + 1;
    function monthToStr(m) {
      return m < 10 ? `0${m}` : m;
    }
    function addMonths(date, months) {
      const d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() !== d) {
        date.setDate(0);
      }
      return date;
    }

    function isSameMonth(a, b) {
      return (
        a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()
      );
    }

    const thisMonth = new Date();
    const nextMonth = addMonths(new Date(), 1);
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table className={classes.table} stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell size="small">年月</TableCell>
                <TableCell size="small" className={classes.mediumCell}>
                  予算
                </TableCell>
                <TableCell className={classes.smallCell}>
                  承認まち金額
                </TableCell>
                <TableCell className={classes.smallCell}>発行済額</TableCell>
                <TableCell className={classes.smallCell}>
                  発行可能残額
                </TableCell>
                <TableCell className={classes.smallCell} />
              </TableRow>
            </TableHead>
            <TableBody>
              {budgetList.map(rowData => {
                let editRow;
                if (editBudgetMode.length > 0) {
                  editRow = editBudgetMode.find(o => o.row === rowData.month);
                }

                // const budgetMonth = rowData.month;
                const budgetMonth = new Date(
                  `${rowData.year}/${rowData.month}/01`
                );
                // const budgetYear = rowData.year;

                let showEditBtn = 'showNum';
                if (
                  (!rowData.requestAmount || rowData.requestStatus === 1) &&
                  (isSameMonth(budgetMonth, thisMonth) ||
                    isSameMonth(budgetMonth, nextMonth))
                ) {
                  showEditBtn = 'canEdit';
                }

                if (
                  budgetMonth > thisMonth &&
                  !isSameMonth(budgetMonth, nextMonth)
                ) {
                  showEditBtn = 'later';
                }

                return (
                  <TableRow>
                    <TableCell size="small">
                      {`${rowData.year}/${monthToStr(rowData.month)}`}
                    </TableCell>
                    <TableCell size="small" className={classes.mediumCell}>
                      <div className={classes.actionCell}>
                        {showEditBtn === 'showNum' &&
                          (rowData.budgetAmount || rowData.requestAmount
                            ? `￥${(
                                rowData.budgetAmount + rowData.requestAmount ||
                                0
                              ).toLocaleString()}`
                            : '￥0')}
                        {showEditBtn === 'canEdit' &&
                          (editRow &&
                          editRow.editMode &&
                          rowData.budgetAmount === undefined ? (
                            <input
                              type="text"
                              className="form-control w-80 text-right"
                              value={budgetAmount}
                              onChange={e => {
                                const value =
                                  parseInt(
                                    e.target.value.replace(/[^\d]/, ''),
                                    0
                                  ) || '';

                                if (value > 100000000) {
                                  alert(
                                    '予算の上限額を超えました。やり直してください。'
                                  );
                                } else {
                                  setBudgetAmount(value);
                                }
                              }}
                            />
                          ) : (
                            <span>
                              {rowData.budgetAmount
                                ? `￥${(
                                    rowData.budgetAmount +
                                      rowData.requestAmount || 0
                                  ).toLocaleString()}`
                                : '予算未設定'}
                            </span>
                          ))}
                        {showEditBtn === 'later' && '予算未設定'}
                        {showEditBtn === 'canEdit' && !!rowData.budgetAmount && (
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={
                              rowData.notApproveAmount &&
                              rowData.notApproveAmount > 0
                            }
                            className={classes.btnEdit}
                            onClick={() => {
                              setShowPopupConfirm(true);
                              setBudgetRowDetail({
                                budgetMonth: rowData.month,
                                budgetAmount: rowData.budgetAmount,
                                budgetId: rowData.budgetId
                              });
                              setBudgetAmount('');
                              console.log('submit');
                            }}
                          >
                            {!(rowData.budgetAmount && rowData.budgetAmount > 0)
                              ? '確定'
                              : '編集'}
                          </Button>
                        )}
                        {showEditBtn === 'canEdit' && !rowData.budgetAmount && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.btnEdit}
                            disabled={
                              editRow && editRow.editMode && !budgetAmount
                            }
                            onClick={e => {
                              if (editRow && editRow.editMode) {
                                setShowPopupConfirm(true);
                                setBudgetRowDetail({
                                  budgetId: rowData.budgetId,
                                  budgetMonth: rowData.month,
                                  budgetAmount
                                });
                                console.log('submit');
                              } else {
                                onEditBudgetMode(e, rowData);
                              }
                            }}
                          >
                            {editRow && editRow.editMode ? '確定' : '編集'}
                          </Button>
                        )}
                      </div>
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      {rowData.requestAmount && rowData.requestStatus !== 1
                        ? `￥${rowData.requestAmount.toLocaleString()}`
                        : '-'}
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      {rowData.usedAmount
                        ? `￥${rowData.usedAmount.toLocaleString()}`
                        : '-'}
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      {rowData.remainAmount
                        ? `￥${rowData.remainAmount.toLocaleString()}`
                        : '-'}
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      <Button
                        className={classes.btnEdit}
                        variant="contained"
                        color="primary"
                        disabled={
                          !(rowData.remainAmount && rowData.remainAmount > 0)
                          // budgetMonth >= currentMonth &&
                          // budgetYear === currentYear
                        }
                        onClick={() => goToGochiIssuance(rowData)}
                      >
                        ごち発行
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
